import byteliveApi from "./api/byteliveApi";
import { objectToQueryString } from "../utils";

const initialState = {};

export default (state = initialState, action) => {
    switch (action.type) {
        default:
            return state;
    }
};

export const castList = (payload) => {
    return (dispatch) => {
        const queryString = objectToQueryString(payload);
        return byteliveApi
            .get(`/cast${queryString}`)
            .then((data) => {
                return data;
            })
            .catch((error) => {
                throw error;
            });
    };
};

export const castUpdatebyAdmin = (id, payload) => {
    return (dispatch) => {
        return byteliveApi
            .patch(`/cast/admin/${id}`, payload)
            .then((data) => {
                return data;
            })
            .catch((error) => {
                throw error;
            });
    };
};
